export default {
  routesWireToInt: routesWireToInt,
  // routesIntToWire: routesIntToWire,
};

function routesWireToInt (wireRoutes) {
  if (!wireRoutes || !wireRoutes.routes || !wireRoutes.routes.route) {
    return [];
  }
  wireRoutes = wireRoutes.routes.route;

  let intRoutes = [];
  for (let i = 0; i < wireRoutes.length; i++) {
    let wireRoute = wireRoutes[ i ];
    intRoutes.push(routeWireToInt(wireRoute._attributes));
  }
  return intRoutes;
}

function routeWireToInt (wireRoute) {
  let routes = getDestinations(wireRoute.depart_flight);
  return {
    id: wireRoute.route_id,
    departure: routes.departure,
    arrival: routes.arrival,
  };
}

function getDestinations (fullRoute) {
  let destination = fullRoute.split('#');
  return {
    departure: destination[ 0 ],
    arrival: destination[ 1 ],
  };
}

// function routesIntToWire (intRoutes) {
//   let wireRoutes = [];
//   for (let i = 0; i < intRoutes.length; i++) {
//     let intRoute = intRoutes[ i ];
//     wireRoutes.push(routeIntToWire(intRoute));
//   }
//   return wireRoutes;
// }

// function routeIntToWire (intRoute) {
//   let departure = intRoute.departure;
//   let arrival = intRoute.arrival;
//   return {
//     _attributes: {
//       route_id: intRoute.id,
//       ret_route: `${arrival} to ${departure}`,
//     },
//     _text: `${departure} to ${arrival}`,
//   };
// }



// WEBPACK FOOTER //
// ./src/converter/RoutesConverter.js